import React from "react";
import { useTranslation } from "react-i18next";

const SaleProductFormStep: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="fs-7">
            <span className="fw-bold">{t("Fill in:")}</span>
            <ul className="mb-3">
                <li>{t("Client information (or select from the database)")}</li>
                <li>{t("Select the employee who sold the product")}</li>
                <li>{t("Select products and specify the quantity")}</li>
                <li>{t("Select the warehouse for product write-off")}</li>
                <li>{t("The price is calculated automatically, but you can manually change it or add a discount")}</li>
                <li>
                    {t(
                        "You can also specify the Payment Status (Paid / Unpaid), Payment Method (Cash / Card), and Comment (if needed)"
                    )}
                </li>
            </ul>
            <p className="m-0 mt-3">
                <strong>{t('Click "Save"')}</strong>
            </p>
        </div>
    );
};

export default SaleProductFormStep;
